module.exports = __webpack_public_path__ + "static/img/1.784784c8.png";